import { Header } from '@/components/layout/Header';
import { useTranslation } from 'react-i18next';
import { usePageMetadata } from '@/hooks/usePageMetadata';
import { Container, Typography, Paper, Box } from '@gapartners/ui';
import { AlertsView } from './AlertsView';

export function AlertsDashboard() {
  const { t } = useTranslation();

  // Set page metadata
  usePageMetadata({
    title: t('pages.manager.alerts.title'),
    description: t('pages.manager.alerts.description'),
  });

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Header />

      {/* Page Header */}
      <Paper
        variant="outlined"
        square
        sx={{
          px: 0,
          py: { xs: 1, sm: 1.25 },
          bgcolor: 'action.hover',
          borderBottom: '1px solid',
          borderColor: 'divider',
          borderLeft: 0,
          borderRight: 0,
          borderTop: 0,
          borderRadius: 0,
        }}
      >
        <Container maxWidth="xl">
          <Typography
            variant="h5"
            fontWeight={600}
            color="text.primary"
            sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' }, mb: 0.5 }}
          >
            {t('pages.manager.alerts.title')}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0 }}>
            {t('pages.manager.alerts.description')}
          </Typography>
        </Container>
      </Paper>

      {/* Content Area */}
      <Container
        maxWidth="xl"
        sx={{ py: { xs: 3, sm: 4 }, px: { xs: 2, sm: 3 } }}
      >
        <AlertsView />
      </Container>
    </Box>
  );
}
